<template>
  <div class="contents autocontents">
    <goods-class-title :src="require('@/assets/images/automation.png')" :imgwidth="883" />
    <goods-automation-item v-for="(auto,index) in autolist" :key="index" :auto="auto" :index="index" />
    <div class="clear"></div>
  </div>
</template>

<script>
import GoodsAutomationItem from './GoodsAutomationItem.vue'
import GoodsClassTitle from './GoodsClassTitle.vue'
export default {
  data(){
      return{
          autolist:{}
      }
  },
  components: { GoodsClassTitle, GoodsAutomationItem },
  methods:{
        articleitemData() {
            const res = this.$api.index.getAutoList()
            this.autolist = res.data.list
        },
  },
  mounted(){
      this.articleitemData();
  }  
}
</script>

<style scoped>
  .autocontents{
    margin-bottom: 150px;
  }
  .contents.brandlist{
      margin-bottom: 145px;
  }

</style>


// WEBPACK FOOTER //
// src/components/index/GoodsAutomation.vue